import React from 'react';
import logo from '../static/practeraEmploy_logo.png';
import Grid from "@material-ui/core/Grid";

function Logo() {
    return (
        <Grid item xs={10} style={{textAlign: "center", paddingTop: "20px", paddingBottom: "20px"}}>
            <img src={logo} alt="Logo" height="100px"/>
        </Grid>
    )
}

export default Logo;
